export interface IBookingsGridResponse {
  isError: boolean;
  errors: string;
  value: Bookings;
}

export interface Bookings {
  bookingsOverview: BookingsData[];
  bookingsOverviewCount: number;
}
  export interface BookingsData {
  taskId: number,
  serviceType: string,
  city: string,
  store: string,
  executionDate:string,
  jobDescription: string,
  leadTime: number,
  orderValue: number,
  leadFee: number,
  rating: number,
  status: string,
  hasWarrantyRequest: boolean
}

export interface ChartData {
  yValue: number;
  xValue: string;
  yLabel: string;
}

export interface IBookingDetailsResponse {
  isError: boolean,
  value: BookingDetails,
  error: string
}

export interface BookingDetails {
  taskId: number,
  serviceType: string,
  executionDate: string,
  city: string,
  orderValue: number,
  serviceProviderName: string,
  status: string,
  jobDescription: string,
  reviewDescription: string,
  rating: number;
  starRating?: string;
  handymanName:string;
  jobDescriptionParagraphs:any
}

export const
  statusMapping = [
    { id: "0", name: 'All' },
    { id: "10", name: 'In progress' },
    { id: "20", name: 'Scheduled' },
    { id: "30", name: 'Completed' },
    { id: "999", name: 'Cancelled' }
  ];

export const bookingGridColumns = [
  'number','receiveDate','serviceType','taskId','city','store', 'executionDate','leadTime','orderValue','leadFee', 'status', 'hasWarrantyRequest' //, 'rating'
]

export const praxisBookingGridColumns = [
  'number','receiveDate','serviceType','taskId','city', 'executionDate','leadTime','orderValue','leadFee', 'status', 'hasWarrantyRequest' //, 'rating'
]